export default __webpack_public_path__ + "static/media/tripWardrobeHome.41592c29.jpeg";